import React from "react";
import { GiClick } from "react-icons/gi";

function Experience({
  experience: { year, degree, company, companyUrl, content },
}) {
  return (
    <div className="entry">
      <div className="title">
        <span>{year}</span>
      </div>
      <div className="body">
        <h4 className="entry-role">{degree}</h4>
        {company && (
          <h6 className="college-name entry-company">
            {companyUrl ? (
              <a href={companyUrl} target="_blank" rel="noopener noreferrer">
                {company} <GiClick />
              </a>
            ) : (
              <span>{company}</span>
            )}
          </h6>
        )}
        {content && <p className="entry-desc">{content}</p>}
      </div>
    </div>
  );
}

export default Experience;
